if (!window.customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.video = this.querySelector('video');
      this.iframe = this.querySelector('iframe');
      this.iframeSrc = this.iframe?.getAttribute('src');
      this.iframeWrapper = this.querySelector('[data-iframe-wrapper]');
      this.placeholderImages = this.querySelectorAll('[data-video-placeholder-image]');
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', () => this.playVideo());
      }
    }

    playVideo() {
      if (this.iframeWrapper) {
        this.iframeWrapper.classList.remove('hidden');
      }

      if (this.iframe) {
        this.iframe.classList.remove('hidden');
        setTimeout(() => this.iframe.classList.remove('opacity-0'), 200);

        if (this.iframeSrc.indexOf('youtube') >= 0) {
          this.iframe.setAttribute('src', `${this.iframeSrc}?autoplay=1&modestbranding=1&autohide=1`);
        } else {
          this.iframe.setAttribute('src', `${this.iframeSrc}?autoplay=1`);
        }
      }

      if (this.video) {
        this.video.classList.remove('hidden');
        this.video.play();
        setTimeout(() => this.video.classList.remove('opacity-0'), 200);
      }

      if (this.button) {
        this.button.classList.add('hidden');
      }

      this.placeholderImages.forEach((image) => {
        image.classList.add('h-0');
        setTimeout(() => {
          image.classList.add('!hidden');
          image.classList.remove('h-0');
        }, 200);
      });
    }
  }

  window.customElements.define('video-player', VideoPlayer);
}